import { createFileRoute } from "@tanstack/react-router";
import { Radio } from "lucide-react";
import { RadioTextToVideo } from "@/components/admin/RadioTextToVideo";
import { LLB_MODULES } from "@/lib/llb-modules";

export const Route = createFileRoute("/_authenticated/portal/admin/llb-story-videos")({
  component: AdminLlbStoryVideos,
});

function AdminLlbStoryVideos() {
  const modules = LLB_MODULES.map((m) => ({
    code: m.code,
    title: m.title,
    notes: m.notes,
  }));

  return (
    <div className="space-y-4 p-4 md:p-6">
      <header className="flex items-start gap-3">
        <div className="grid h-10 w-10 place-items-center rounded-md bg-navy text-navy-foreground">
          <Radio className="h-5 w-5" />
        </div>
        <div>
          <h1 className="font-display text-2xl text-navy">LLB story videos</h1>
          <p className="text-sm text-muted-foreground">
            Generate scripted, multi-character story episodes derived from a
            UNISA LLB module's syllabus, then record them as branded videos for
            enrolled students.
          </p>
        </div>
      </header>

      <RadioTextToVideo
        defaultDomain="llb"
        llbModules={modules}
        defaultModuleCode={modules[0]?.code}
        title="LLB module story video"
      />
    </div>
  );
}
